import React from "react"
import "./welcome.css"


export default function Welcome(props) {

    return <div className="welcome-holder">
        <div className="welcome">
            <p>Welcome to Quizzical</p>
            <button onClick={props.onClick}>Start Quiz</button>
        </div>
    </div>
}

